// extracted by mini-css-extract-plugin
export default {"brandContainer":"home_brandContainer__vecaB","brandheading":"home_brandheading__GX6X-"};